import { Directive, ElementRef, Renderer2, AfterViewInit, HostListener } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '.scroll-to-top-btn',
    standalone: false
})
export class ScrollTopBtnDirective implements AfterViewInit {

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) { }

  ngAfterViewInit() {
    this.updateVisibility();
  }

  @HostListener('click')
  onClick() {
    this.smoothScrollToTop();
  }

  @HostListener('window:scroll')
  onScroll() {
    this.updateVisibility();
  }

  private updateVisibility() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    
    if (scrollPosition > 600) {
      this.renderer.addClass(this.el.nativeElement, 'visible');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'visible');
    }
  }

  private smoothScrollToTop() {
    const scrollDuration = 1200; // duration in ms
    const scrollStep = -window.scrollY / (scrollDuration / 15);
    
    // Implementation of smooth scroll using requestAnimationFrame
    const scrollInterval = setInterval(() => {
      if (window.scrollY !== 0) {
        window.scrollBy(0, scrollStep);
      } else {
        clearInterval(scrollInterval);
      }
    }, 15);

    // Alternative implementation with native smooth scrolling (modern browsers)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}